/**
 * The default argument placeholder value for methods.
 *
 * @type {Object}
 */
module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./node_modules/lodash/fp/placeholder.js
// module id = 93
// module chunks = 0